import { AuthorizedPreferences } from '../shared-authorized';

export class TeacherPreferences extends AuthorizedPreferences {
}

export const teacherPreferences = new TeacherPreferences();
